import { PublicUsefulLinksApi } from 'SharedDir/backend/api';
import { useList } from 'SharedDir/common/composables/useList';

import { usePublicUsefulLinksFilters } from './usePublicUsefulLinksFilters';

export function usePublicUsefulLinksList() {
  const {
    combinedParameters,
    fetch,
    list,
    paginationParams,
    filterParams,
    onRequest,
    clearParameters,
    fillFromQueryString,
    fillFromQueryStringSsr,
    defaultFilterParams,
    setQueryParams,
  } = useList(usePublicUsefulLinksFilters, PublicUsefulLinksApi, true, {
    descending: true,
    rowsPerPage: 24,
  });

  return {
    combinedParameters,
    fetch,
    list,
    paginationParams,
    filterParams,
    onRequest,
    clearParameters,
    fillFromQueryString,
    fillFromQueryStringSsr,
    defaultFilterParams,
    setQueryParams,
  };
}
